export type Language = 'en' | 'te' | 'hi';

export const translations = {
  en: {
    appName: 'Prakruthi Mithra',
    appSubtitle: 'Natural Farming Guide',
    home: 'Home',
    crops: 'Crops',
    inputs: 'Kashayams',
    handbook: 'Handbook',
    advisor: 'AI Advisor',
    forum: 'Forum',
    profile: 'Profile',
    videos: 'Videos',
    scanner: 'Scanner',
    login: 'Login',
    signup: 'Sign Up',
    logout: 'Logout',
    offline: 'Offline',
    welcome: 'Welcome to Prakruthi Mithra',
    tagline: 'Protect the earth and save health with Prakruthi Vyavasayam (Natural Farming).',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    naturalFarmingIntro: 'Introduction to Natural Farming',
    naturalFarmingDesc: 'The use of chemical fertilizers not only reduces soil fertility but also poses a threat to our health. Through natural farming, more profit can be obtained with less investment.',
    naturalKashayams: 'Natural Kashayams',
    pests: 'Pests/Diseases',
    preparations: 'Preparation Method',
    ingredients: 'Ingredients',
    usage: 'Usage Method',
    sowingTime: 'Sowing Time',
    description: 'Description',
    back: 'Back',
    search: 'Search',
    language: 'Language',
    selectLanguage: 'Select Language',
    telugu: 'Telugu',
    english: 'English',
    hindi: 'Hindi',
    changeLanguage: 'Change Language',
    menu: 'Menu',
    settings: 'Settings',
    adminPanel: 'Admin Panel',
    calculators: 'Calculators',
    pages: 'Pages',
    editCategoryName: 'Edit Category Name',
    save: 'Save',
    cancel: 'Cancel',
    addNewCategory: 'Add New Category',
    categoryName: 'Category Name',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    subcategoryName: 'Subcategory Name',
    addNewSubcategory: 'Add New Subcategory',
    privacyPolicy: 'Privacy Policy',
    contentMarkdown: 'Content (Markdown support)',
    enterPrivacyContent: 'Enter privacy policy content...',
    privacySaved: 'Privacy policy saved successfully!',
    savePrivacy: 'Save Privacy Policy',
    termsAndConditions: 'Terms & Conditions',
    enterTermsContent: 'Enter terms & conditions content...',
    termsSaved: 'Terms & conditions saved successfully!',
    saveTerms: 'Save Terms & Conditions',
    aboutUs: 'About Us',
    marketPrices: 'Market Prices',
    seedCommonPrices: 'Seed Common Prices',
    localMarketPrices: 'Local Market Prices',
    verifiedLocalPrices: 'Verified Local Prices',
    manageVerifiedPrices: 'Manage verified prices that appear in the app.',
    addNewPrice: 'Add New Price',
    cropName: 'Crop Name',
    pricePerQuintal: 'Price (per quintal)',
    trend: 'Trend',
    savePrice: 'Save Price',
    editPrice: 'Edit Market Price',
    noVerifiedPrices: 'No verified prices added yet.',
    seedPricesInstructions: 'Click "Seed Common Prices" to quickly add realistic data.',
    addNewCalculator: 'Add New Calculator',
    editVideo: 'Edit Video',
    videoTitle: 'Video Title',
    videoUrl: 'Video URL',
    addNewVideo: 'Add New Video',
    editItem: 'Edit Item',
    itemName: 'Item Name',
    thumbnailImage: 'Thumbnail Image',
    uploadImage: 'Upload Image',
    changeImage: 'Change Image',
    sections: 'Sections',
    addSection: 'Add Section',
    title: 'Title',
    content: 'Content',
    enterDetails: 'Enter details here...',
    noSections: 'No sections added yet.',
    saveAndSync: 'Save & Sync',
    editCalculator: 'Edit Calculator',
    baseRate: 'Base Rate (kg/acre)',
    rows: 'Rows',
    addRow: 'Add Row',
    label: 'Label',
    sublabel: 'Sub Label',
    ratio: 'Ratio',
    kgPerAcre: 'kg/acre',
    saveCalculator: 'Save Calculator',
    play: 'Play',
    noVideos: 'No videos found.',
    noSubcategories: 'No subcategories found.',
    noCalculators: 'No calculators found.',
    noCropsFound: 'No crops found in notebook.',
    noInputsFound: 'No kashayams found in notebook.',
    moreInfo: 'More Info',
    profileUpdated: 'Profile updated successfully!',
    profileUpdateFailed: 'Failed to update profile.',
    farmerBrother: 'Farmer Brother',
    fullName: 'Full Name',
    yourName: 'Your Name',
    phoneNumber: 'Phone Number',
    yourPhoneNumber: 'Your Phone Number',
    location: 'Location',
    villageTown: 'Village/Town',
    enterFullName: 'Enter your full name',
    enterPhoneNumber: 'Enter your phone number',
    enterVillageName: 'Enter your village name',
    updating: 'Updating...',
    updateDetails: 'Update Details',
    passwordResetSent: 'Password reset link sent to your email.',
    passwordTooShort: 'Password must be at least 6 characters.',
    invalidEmail: 'Please enter a valid email address.',
    somethingWentWrong: 'Something went wrong. Please try again.',
    forgotPassword: 'Forgot Password?',
    verifyEmail: 'Verify your email',
    verificationSent: 'We have sent you a verification email:',
    pleaseVerify: 'Please verify it and login.',
    backToLogin: 'Back to Login',
    userAlreadyExists: 'User already exists. Please login.',
    incorrectEmailPassword: 'Incorrect email or password',
    hello: 'Hello',
    helloFarmer: 'Hello Farmer Brother!',
    askAI: 'Ask AI',
    dailyWeather: "Today's Weather",
    dataNotAvailable: 'Data not available',
    locationRequired: 'Location access required for local weather',
    weatherLoadFailed: 'Weather info failed to load',
    humidity: 'Humidity',
    suitableForNaturalFarming: '✓ Suitable for Farming',
    notSuitableForFarming: '⚠ Conditions not ideal for work',
    high: 'High',
    low: 'Low',
    wind: 'Wind',
    clickForForecast: 'Click for 10-day forecast',
    communityForum: 'Farmer Forum',
    shareExperience: 'Share your experiences, learn from others.',
    aiAdvisor: 'AI Advisor',
    forecast10Days: '10-Day Weather Forecast',
    today: 'Today',
    acresCount: 'Number of Acres:',
    totalPerAcre: 'Total (per acre):',
    importantNote: 'Important Note',
    naturalFarmingBenefit: 'The use of chemical fertilizers not only reduces soil fertility but also poses a threat to our health. Through natural farming, more profit can be obtained with less investment.',
    resetConfirmation: 'Are you sure you want to reset all data? This will clear Firestore and re-seed with initial data.',
    resetSuccess: 'Data reset successfully!',
    resetError: 'Error resetting data. Check console.',
    deleteVideoConfirm: 'Delete this video?',
    deleteCalculatorConfirm: 'Delete this calculator?',
    deleteCategoryConfirm: 'Delete this category and all its items?',
    deleteSubcategoryConfirm: 'Delete this subcategory?',
    noSubcategoriesYet: 'No subcategories yet.',
    uploadThumbnail: 'Upload Thumbnail',
    noVideosYet: 'No videos added yet.',
    noDetailsAvailable: 'No details available for this item yet.',
    noMedia: 'No Media',
    email: 'Email',
    password: 'Password',
    processing: 'Processing...',
    sendResetLink: 'Send Reset Link',
    alreadyHaveAccount: 'Already have an account? Login',
    dontHaveAccount: "Don't have an account? Sign Up",
    adMobConfig: 'AdMob Configuration',
    bannerAdId: 'Banner Ad Unit ID',
    interstitialAdId: 'Interstitial Ad Unit ID',
    rewardedAdId: 'Rewarded Ad Unit ID',
    testMode: 'Test Mode',
    adMobSaved: 'AdMob configuration saved successfully!',
    saveAdMob: 'Save AdMob Configuration',
    reportGeneratedVia: 'Check out this report generated via Prakruthi Mithra AI.',
    sharedVia: 'Shared via Prakruthi Mithra AI',
    acres: 'Acres',
    total: 'Total',
    accessDenied: 'Access Denied. Only admins can access this panel.',
    noContentYet: 'No content yet. Please add content in admin panel.',
    resetAppData: 'Reset App Data',
    resetting: 'Resetting...',
    resetData: 'Reset Data',
    currentLocation: 'Current Location',
    vijayawada: 'Vijayawada',
    sunny: 'Sunny',
    mainlyClear: 'Mainly Clear',
    partlyCloudy: 'Partly Cloudy',
    cloudy: 'Cloudy',
    fog: 'Fog',
    drizzle: 'Drizzle',
    rain: 'Rain',
    heavyRain: 'Heavy Rain',
    thunderstorm: 'Thunderstorm',
    snow: 'Snow',
    newCalculator: 'New Calculator',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    moveItemUp: 'Move Item Up',
    moveItemDown: 'Move Item Down',
    moveSectionUp: 'Move Section Up',
    moveSectionDown: 'Move Section Down',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    weatherAlerts: 'Weather Alerts',
    noAlerts: 'No alerts at the moment',
    heavyRainAlert: 'Heavy rain forecast! Take crop protection measures.',
    highTempAlert: 'High temperature! Provide adequate water.',
    stormAlert: 'Storm warning! Stay safe.',
    heatWaveAlert: 'Heat wave warning! Avoid going out in the afternoon.',
    frostAlert: 'Frost possible! Keep the crop covered.',
    fungalAlert: 'High humidity detected (>90%). Risk of fungal diseases. Monitor crops.',
    visibilityAlert: 'Dense fog detected! Low visibility, be careful on the field.',
    rainChanceAlert: 'High probability of rain today. Plan your activities accordingly.',
    changeLocation: 'Change Location',
    searchLocation: 'Search for your city/village',
    detectLocation: 'Detect Location',
    realFeel: 'Real Feel',
    uvIndex: 'UV Index',
    lowUV: 'Low',
    moderateUV: 'Moderate',
    highUV: 'High',
    veryHighUV: 'Very High',
    extremeUV: 'Extreme',
    weatherSummary: 'Weather Summary',
    lastUpdated: 'Last updated',
    rainChance: 'Chance of rain',
    searching: 'Searching...',
    locationNotFound: 'Location not found',
    expertConnect: 'Expert Connect',
    manageExperts: 'Manage Experts',
    viewMessages: 'User Messages',
    expertMessages: 'User Inquiries',
    marketplace: 'Marketplace',
    plantDoctor: 'Plant Doctor',
    apcnfTraceability: 'APCNF Traceability',
    cropCalendar: 'Crop Calendar',
    plantingMonth: 'Planting Month',
    harvestMonth: 'Harvest Month',
    recommendedCrops: 'Recommended Crops',
    addNewCropEntry: 'Add New Crop Entry',
    editCropEntry: 'Edit Crop Entry',
    cropNameEn: 'Crop Name (EN)',
    cropNameTe: 'Crop Name (TE)',
    cropNameHi: 'Crop Name (HI)',
    detailsEn: 'Details (EN)',
    detailsTe: 'Details (TE)',
    detailsHi: 'Details (HI)',
    practices: 'Practices',
    dayOffset: 'Days from sowing',
    addPractice: 'Add Practice',
    sowingDate: 'Sowing Date',
    editSowingDate: 'Edit Sowing Date',
    followCrop: 'Follow Crop',
    unfollowCrop: 'Unfollow Crop',
    unfollowCropConfirm: 'Are you sure you want to stop following this crop?',
    following: 'Following',
    noCropsFoundCalendar: 'No recommended crops found for this month.',
    viewPractices: 'View Practices',
    hidePractices: 'Hide Practices',
    weeklyPractices: 'Weekly Practices',
    markAsComplete: 'Mark as Complete',
    completed: 'Completed',
    noPracticesThisWeek: 'No practices for this week.',
    daysSinceSowing: 'Days since sowing',
    selectSowingDate: 'Select Sowing Date',
    followCropConfirm: 'Do you want to follow this crop and receive weekly practices?',
    practiceTitleEn: 'Practice Title (EN)',
    practiceTitleTe: 'Practice Title (TE)',
    practiceTitleHi: 'Practice Title (HI)',
    practiceDetailsEn: 'Practice Details (EN)',
    practiceDetailsTe: 'Practice Details (TE)',
    practiceDetailsHi: 'Practice Details (HI)',
    farmingMethod: 'Farming Method',
    farmingMethods: 'Farming Methods',
    certifications: 'Certifications',
    organicCertificates: 'Organic Certificates',
    buySellProduce: 'Buy and sell natural produce',
    copy: 'Copy',
    share: 'Share',
    linkCopied: 'Content copied to clipboard',
    reportSharedDesktop: 'Report downloaded and details copied to clipboard.',
    detailsCopied: 'Details copied to clipboard.',
    liveMarketPrices: 'Live Market Prices',
    searchCrops: 'Search crops...',
    selectDistrict: 'Select District',
    selectState: 'Select State',
    fetchingPrices: 'Fetching market prices...',
    errorFetchingPrices: 'Error fetching market prices. Please try again later.',
    noPricesFound: 'No prices found for the selected filters.',
    minPrice: 'Min Price',
    maxPrice: 'Max Price',
    modalPrice: 'Modal Price',
    market: 'Market',
    commodity: 'Commodity',
    variety: 'Variety',
    arrivalDate: 'Arrival Date',
    refreshing: 'Refreshing...',
    clearFilters: 'Clear Filters',
    menuManagement: 'Menu Management',
    profileFieldsManagement: 'Profile Fields Management',
    labelKey: 'Label Key',
    placeholderKey: 'Placeholder Key',
    adminOnly: 'Admin Only',
    visible: 'Visible',
    required: 'Required',
    deleteConfirm: 'Are you sure you want to delete this?',
    updateSuccess: 'Listing updated successfully!',
    postSuccess: 'Listing posted successfully!',
    profileUpdateSuccess: 'Profile updated successfully!',
    updateError: 'Failed to update listing.',
    postError: 'Failed to post listing.',
    loginSuccess: 'Logged in successfully!',
    loginFailed: 'Login failed. Please try again.',
    signInWithGoogle: 'Sign in with Google',
    showInterstitialAd: 'Show Interstitial Ad',
    showRewardedAd: 'Watch Video for Reward',
    adRewardSuccess: 'Congratulations! You earned a reward.',
    or: 'OR',
    addNewPage: 'Add New Page',
    editPage: 'Edit Page',
    pageTitle: 'Page Title',
    pageSlug: 'Page slug (URL e.g. about-us)',
    savePage: 'Save Page',
    noPagesYet: 'No pages created yet.',
    deletePageConfirm: 'Are you sure you want to delete this page?',
    contentInTelugu: 'Content in Telugu',
    contentInHindi: 'Content in Hindi',
    contentInEnglish: 'Content in English',
    enterLogoUrl: 'Enter Logo URL',
    brandingSettings: 'App Branding',
    appLogo: 'App Logo',
    logoUploadInstructions: 'Upload an image or enter a URL for the application logo. This will be shown on the login and registration pages.',
    uploadLogo: 'Upload Photo',
    branding: 'Branding',
    userRole: 'User Role',
    farmer: 'Farmer',
    aggregator: 'Aggregator',
    buyer: 'Buyer',
    farmerId: 'Farmer ID',
    enterFarmerId: 'Enter Farmer ID',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully!',
    passwordMismatch: 'Passwords do not match.',
    currentPassword: 'Current Password',
    roleRequired: 'Please select a role.',
    cultivationPractices: 'Cultivation Practices',
    practicedSince: 'Practicing since',
    practicesFollowed: 'Practices Followed',
    addPracticePhoto: 'Add Practice Photo',
    cropDetails: 'Crop Details',
    harvestTime: 'Estimated Harvest Time',
    cultivationArea: 'Cultivation Area',
    latitude: 'Latitude',
    longitude: 'Longitude',
    areaDetails: 'Area Details',
    ratingsAndFeedback: 'Ratings & Feedback',
    provideFeedback: 'Provide Feedback',
    rating: 'Rating',
    feedback: 'Feedback',
    submitFeedback: 'Submit Feedback',
    viewProfileQR: 'View Profile QR',
    downloadQR: 'Download QR',
    manageProfileSequence: 'Manage Profile Sequence',
    arrangeProfile: 'Arrange Profile Elements',
    saveSequence: 'Save Sequence',
    farmerProfile: 'Farmer Profile',
    jeevamrutham: 'Jeevamrutham (Solid/Liquid)',
    beejamrutham: 'Beejamrutham (Seed Treatment)',
    herbalDecoctions: 'Herbal Decoctions & Solutions',
    otherPractices: 'Other Practices',
    addCropRecord: 'Add Crop Record',
    estimatedHarvest: 'Estimated Harvest',
    cropArea: 'Crop Area',
    commonCrops: ['Paddy', 'Cotton', 'Groundnut', 'Maize', 'Chilli', 'Tomato', 'Onion', 'Bengal Gram', 'Turmeric', 'Red Gram', 'Green Gram', 'Black Gram', 'Sunflower', 'Soyabean', 'Wheat', 'Sugarcane', 'Potato', 'Banana'],
  },
  te: {
    appName: 'ప్రకృతి మిత్ర',
    appSubtitle: 'ప్రకృతి వ్యవసాయ మార్గదర్శి',
    home: 'హోమ్',
    crops: 'పంటలు',
    inputs: 'కషాయాలు',
    handbook: 'హ్యాండ్‌బుక్',
    advisor: 'AI సలహాదారు',
    forum: 'ఫోరమ్',
    profile: 'ప్రొఫైల్',
    videos: 'వీడియోలు',
    scanner: 'స్కానర్',
    login: 'లాగిన్',
    signup: 'సైన్ అప్',
    logout: 'లాగ్ అవుట్',
    offline: 'ఆఫ్‌లైన్',
    welcome: 'ప్రకృతి మిత్రకు స్వాగతం',
    tagline: 'ప్రకృతి వ్యవసాయంతో భూమిని రక్షించండి, ఆరోగ్యాన్ని కాపాడండి.',
    getStarted: 'ప్రారంభించండి',
    learnMore: 'మరింత తెలుసుకోండి',
    naturalFarmingIntro: 'ప్రకృతి వ్యవసాయం పరిచయం',
    naturalFarmingDesc: 'రసాయన ఎరువుల వాడకం వల్ల నేల సారం తగ్గిపోవడమే కాకుండా, మన ఆరోగ్యానికి కూడా ముప్పు. ప్రకృతి వ్యవసాయం ద్వారా తక్కువ పెట్టుబడితో ఎక్కువ లాభం పొందవచ్చు.',
    naturalKashayams: 'ప్రకృతి కషాయాలు',
    pests: 'పురుగులు/వ్యాధులు',
    preparations: 'తయారీ విధానం',
    ingredients: 'కావలసినవి',
    usage: 'వాడే విధానం',
    sowingTime: 'విత్తే సమయం',
    description: 'వివరణ',
    back: 'వెనుకకు',
    search: 'వెతకండి',
    language: 'భాష',
    selectLanguage: 'భాషను ఎంచుకోండి',
    telugu: 'తెలుగు',
    english: 'English',
    hindi: 'Hindi',
    changeLanguage: 'భాషను మార్చండి',
    menu: 'మెనూ',
    settings: 'సెట్టింగ్‌లు',
    adminPanel: 'అడ్మిన్ ప్యానెల్',
    calculators: 'క్యాలిక్యులేటర్లు',
    pages: 'పేజీలు',
    editCategoryName: 'కేటగిరీ పేరును సవరించండి',
    save: 'సేవ్ చేయండి',
    cancel: 'రద్దు చేయండి',
    addNewCategory: 'కొత్త కేటగిరీని జోడించండి',
    categoryName: 'కేటగిరీ పేరు',
    add: 'జోడించు',
    edit: 'సవరించు',
    delete: 'తొలగించు',
    subcategoryName: 'సబ్ కేటగిరీ పేరు',
    addNewSubcategory: 'కొత్త సబ్ కేటగిరీని జోడించండి',
    privacyPolicy: 'ప్రైవసీ పాలసీ',
    contentMarkdown: 'కంటెంట్ (మార్క్ డౌన్ సపోర్ట్ ఉంది)',
    enterPrivacyContent: 'ప్రైవసీ పాలసీ కంటెంట్‌ను నమోదు చేయండి...',
    privacySaved: 'ప్రైవసీ పాలసీ విజయవంతంగా సేవ్ చేయబడింది!',
    savePrivacy: 'ప్రైవసీ పాలసీని సేవ్ చేయండి',
    termsAndConditions: 'నిబంధనలు & షరతులు',
    enterTermsContent: 'నిబంధనలు & షరతుల కంటెంట్‌ను నమోదు చేయండి...',
    termsSaved: 'నిబంధనలు & షరతులు విజయవంతంగా సేవ్ చేయబడ్డాయి!',
    saveTerms: 'నిబంధనలు & షరతులను సేవ్ చేయండి',
    aboutUs: 'మా గురించి',
    marketPrices: 'మార్కెట్ ధరలు',
    seedCommonPrices: 'సాధారణ ధరలను జోడించండి',
    localMarketPrices: 'స్థానిక మార్కెట్ ధరలు',
    verifiedLocalPrices: 'ధృవీకరించబడిన స్థానిక ధరలు',
    manageVerifiedPrices: 'యాప్‌లో కనిపించే ధృవీకరించబడిన ధరలను నిర్వహించండి.',
    addNewPrice: 'కొత్త ధరను జోడించండి',
    cropName: 'పంట పేరు',
    pricePerQuintal: 'ధర (క్వింటాల్‌కు)',
    trend: 'ట్రెండ్',
    savePrice: 'ధరను సేవ్ చేయి',
    editPrice: 'మార్కెట్ ధరను సవరించండి',
    noVerifiedPrices: 'ధృవీకరించబడిన ధరలు ఇంకా జోడించలేదు.',
    seedPricesInstructions: 'వాస్తవిక డేటాను త్వరగా జోడించడానికి "సాధారణ ధరలను జోడించండి" క్లిక్ చేయండి.',
    addNewCalculator: 'కొత్త క్యాలిక్యులేటర్‌ను జోడించండి',
    editVideo: 'వీడియోను సవరించండి',
    videoTitle: 'వీడియో శీర్షిక',
    videoUrl: 'వీడియో URL',
    addNewVideo: 'కొత్త వీడియోను జోడించండి',
    editItem: 'అంశాన్ని సవరించండి',
    itemName: 'అంశం పేరు',
    thumbnailImage: 'థంబ్‌నెయిల్ చిత్రం',
    uploadImage: 'చిత్రాన్ని అప్‌లోడ్ చేయండి',
    changeImage: 'చిత్రాన్ని మార్చండి',
    sections: 'విభాగాలు',
    addSection: 'విభాగాన్ని జోడించండి',
    title: 'శీర్షిక',
    content: 'కంటెంట్',
    enterDetails: 'వివరాలను ఇక్కడ నమోదు చేయండి...',
    noSections: 'ఇంకా విభాగాలు జోడించబడలేదు.',
    saveAndSync: 'సేవ్ & సింక్',
    editCalculator: 'క్యాలిక్యులేటర్ సవరించు',
    baseRate: 'బేస్ రేట్ (కేజీ/ఎకరం)',
    rows: 'వరుసలు',
    addRow: 'వరుసను జోడించండి',
    label: 'లేబుల్',
    sublabel: 'సబ్ లేబుల్',
    ratio: 'నిష్పత్తి',
    kgPerAcre: 'కేజీ/ఎకరం',
    saveCalculator: 'క్యాలిక్యులేటర్‌ను సేవ్ చేయండి',
    play: 'ప్లే చేయండి',
    noVideos: 'వీడియోలు ఏవీ లేవు.',
    noSubcategories: 'సబ్ కేటగిరీలు ఏవీ లేవు.',
    noCalculators: 'క్యాలిక్యులేటర్లు ఏవీ లేవు.',
    noCropsFound: 'నోట్‌బుక్‌లో పంటలు ఏవీ లేవు.',
    noInputsFound: 'నోట్‌బుక్‌లో కషాయాలు ఏవీ లేవు.',
    moreInfo: 'మరింత సమాచారం',
    profileUpdated: 'ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది!',
    profileUpdateFailed: 'ప్రొఫైల్ నవీకరించడంలో విఫలమైంది.',
    farmerBrother: 'రైతు సోదరుడు',
    fullName: 'పూర్తి పేరు',
    yourName: 'మీ పేరు',
    phoneNumber: 'ఫోన్ నంబర్',
    yourPhoneNumber: 'మీ ఫోన్ నంబర్',
    location: 'ప్రాంతం',
    villageTown: 'గ్రామం/పట్టణం',
    enterFullName: 'మీ పూర్తి పేరును నమోదు చేయండి',
    enterPhoneNumber: 'మీ ఫోన్ నంబర్‌ను నమోదు చేయండి',
    enterVillageName: 'మీ గ్రామం పేరును నమోదు చేయండి',
    updating: 'నవీకరిస్తోంది...',
    updateDetails: 'వివరాలను నవీకరించండి',
    passwordResetSent: 'పాస్‌వర్డ్ రీసెట్ లింక్ మీ ఈమెయిల్‌కు పంపబడింది.',
    passwordTooShort: 'పాస్‌వర్డ్ కనీసం 6 అక్షరాలు ఉండాలి.',
    invalidEmail: 'సరైన ఈమెయిల్ అడ్రస్ ఇవ్వండి.',
    somethingWentWrong: 'సమస్య ఏర్పడింది. దయచేసి మళ్ళీ ప్రయత్మంది.',
    forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
    verifyEmail: 'మీ ఈమెయిల్‌ను ధృవీకరించండి',
    verificationSent: 'మేము మీకు ధృవీకరణ ఈమెయిల్‌ను పంపాము:',
    pleaseVerify: 'దయచేసి దానిని ధృవీకరించి లాగిన్ అవ్వండి.',
    backToLogin: 'తిరిగి లాగిన్‌కు',
    userAlreadyExists: 'వినియోగదారు ఇప్పటికే ఉన్నారు. దయచేసి లాగిన్ అవ్వండి',
    incorrectEmailPassword: 'ఈమెయిల్ లేదా పాస్‌వర్డ్ తప్పు',
    hello: 'నమస్కారం',
    helloFarmer: 'నమస్కారం రైతు సోదరా!',
    askAI: 'AI ని అడుగు',
    dailyWeather: 'నేటి వాతావరణం',
    dataNotAvailable: 'డేటా అందుబాటులో లేదు',
    locationRequired: 'స్థానిక వాతావరణం కోసం స్థాన ప్రాప్యత అవసరం',
    weatherLoadFailed: 'వాతావరణ సమాచారం లోడ్ కాలేదు',
    humidity: 'తేమ',
    suitableForNaturalFarming: '✓ పనులు చేయడానికి అనుకూలం',
    notSuitableForFarming: '⚠ పనులు చేయడానికి అనుకూలంగా లేదు',
    high: 'గరిష్ట',
    low: 'కనిష్ట',
    wind: 'గాలి వేగం',
    clickForForecast: '10 రోజుల నివేదిక చూడటానికి క్లిక్ చేయండి',
    communityForum: 'రైతు చర్చా వేదిక (Forum)',
    shareExperience: 'మీ అనుభవాలను పంచుకోండి, ఇతరుల నుండి నేర్చుకోండి.',
    aiAdvisor: 'AI సలహాదారు',
    forecast10Days: '10 రోజుల వాతావరణ నివేదిక',
    today: 'నేడు',
    acresCount: 'ఎకరాల సంఖ్య:',
    totalPerAcre: 'మొత్తం (per acre):',
    importantNote: 'ముఖ్య గమనిక',
    naturalFarmingBenefit: 'రసాయన ఎరువుల వాడకం వల్ల నేల సారం తగ్గిపోవడమే కాకుండా, మన ఆరోగ్యానికి కూడా ముప్పు. ప్రకృతి వ్యవసాయం ద్వారా తక్కువ పెట్టుబడితో ఎక్కువ లాభం పొందవచ్చు.',
    resetConfirmation: 'మీరు ఖచ్చితంగా మొత్తం డేటాను రీసెట్ చేయాలనుకుంటున్నారా? ఇది ఫైర్‌స్టోర్‌ను క్లియర్ చేస్తుంది మరియు ప్రారంభ డేటాతో మళ్లీ సీడ్ చేస్తుంది.',
    resetSuccess: 'డేటా విజయవంతంగా రీసెట్ చేయబడింది!',
    resetError: 'డేటాను రీసెట్ చేయడంలో లోపం. కన్సోల్‌ను తనిఖీ చేయండి.',
    deleteVideoConfirm: 'ఈ వీడియోను తొలగించాలా?',
    deleteCalculatorConfirm: 'ఈ క్యాలిక్యులేటర్‌ను తొలగించాలా?',
    deleteCategoryConfirm: 'ఈ కేటగిరీని మరియు దానిలోని అన్ని అంశాలను తొలగించాలా?',
    deleteSubcategoryConfirm: 'ఈ సబ్ కేటగిరీని తొలగించాలా?',
    noSubcategoriesYet: 'ఇంకా సబ్ కేటగిరీలు లేవు.',
    uploadThumbnail: 'థంబ్‌నెయిల్ అప్‌లోడ్ చేయండి',
    noVideosYet: 'ఇంకా వీడియోలు జోడించబడలేదు.',
    noDetailsAvailable: 'ఈ అంశానికి ఇంకా వివరాలు అందుబాటులో లేవు.',
    noMedia: 'మీడియా లేదు',
    email: 'ఈమెయిల్',
    password: 'పాస్‌వర్డ్',
    processing: 'ప్రాసెస్ అవుతోంది...',
    sendResetLink: 'రీసెట్ లింక్ పంపండి',
    alreadyHaveAccount: 'ఇప్పటికే ఖాతా ఉందా? లాగిన్ అవ్వండి',
    dontHaveAccount: 'ఖాతా లేదా? సైన్ అప్ చేయండి',
    adMobConfig: 'AdMob కన్ఫిగరేషన్',
    bannerAdId: 'బ్యానర్ యాడ్ యూనిట్ ID',
    interstitialAdId: 'ఇంటర్ స్టీషియల్ యాడ్ యూనిట్ ID',
    rewardedAdId: 'రివార్డ్ యాడ్ యూనిట్ ID',
    testMode: 'టెస్ట్ మోడ్',
    adMobSaved: 'AdMob కన్ఫిగరేషన్ విజయవంతంగా సేవ్ చేయబడింది!',
    saveAdMob: 'AdMob కన్ఫిగరేషన్ సేవ్ చేయండి',
    reportGeneratedVia: 'ప్రకృతి మిత్ర AI ద్వారా రూపొందించబడిన ఈ నివేదికను చూడండి.',
    sharedVia: 'ప్రకృతి మిత్ర AI ద్వారా భాగస్వామ్యం చేయబడింది',
    acres: 'ఎకరాలు',
    total: 'మొత్తం',
    accessDenied: 'యాక్సెస్ నిరాకరించబడింది. నిర్వాహకులు మాత్రమే ఈ ప్యానెల్‌ను యాక్సెస్ చేయగలరు.',
    noContentYet: 'ఇంకా కంటెంట్ లేదు. దయచేసి అడ్మిన్ ప్యానెల్‌లో కంటెంట్‌ను జోడించండి.',
    resetAppData: 'యాప్ డేటాను రీసెట్ చేయండి',
    resetting: 'రీసెట్ అవుతోంది...',
    resetData: 'డేటా రీసెట్',
    currentLocation: 'ప్రస్తుత ప్రాంతం',
    vijayawada: 'విజయవాడ',
    sunny: 'ఎండగా ఉంది',
    mainlyClear: 'చాలా వరకు స్పష్టంగా ఉంది',
    partlyCloudy: 'పాక్షికంగా మేఘావృతమై ఉంది',
    cloudy: 'మేఘావృతమై ఉంది',
    fog: 'మంచు కురుస్తోంది',
    drizzle: 'చినుకులు పడుతున్నాయి',
    rain: 'వర్షం పడుతోంది',
    heavyRain: 'భారీ వర్షం',
    thunderstorm: 'ఉరుములు మరియు మెరుపులతో కూడిన వర్షం',
    snow: 'మంచు కురుస్తోంది',
    newCalculator: 'కొత్త క్యాలిక్యులేటర్',
    moveUp: 'పైకి జరపండి',
    moveDown: 'క్రిందికి జరపండి',
    moveItemUp: 'అంశాన్ని పైకి జరపండి',
    moveItemDown: 'అంశాన్ని క్రిందికి జరపండి',
    moveSectionUp: 'విభాగాన్ని పైకి జరపండి',
    moveSectionDown: 'విభాగాన్ని క్రిందికి జరపండి',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    weatherAlerts: 'వాతావరణ హెచ్చరికలు',
    noAlerts: 'ప్రస్తుతానికి ఎటువంటి హెచ్చరికలు లేవు',
    heavyRainAlert: 'భారీ వర్షం సూచన! పంట రక్షణ చర్యలు తీసుకోండి.',
    highTempAlert: 'అధిక ఉష్ణోగ్రత! తగినంత నీరు అందించండి.',
    stormAlert: 'తుఫాను హెచ్చరిక! సురక్షితంగా ఉండండి.',
    heatWaveAlert: 'వడగాల్పుల హెచ్చరిక! మధ్యాహ్నం వేళల్లో బయటకు వెళ్లకండి.',
    frostAlert: 'మంచు కురిసే అవకాశం! పంటను కప్పి ఉంచండి.',
    fungalAlert: 'అధిక తేమ ( >90%) ఉంది. శిలీంధ్ర వ్యాధుల ముప్పు ఉంది. పంటను గమనించండి.',
    visibilityAlert: 'దట్టమైన మంచు ఉంది! తక్కువ దృశ్యమానత, జాగ్రత్తగా ఉండండి.',
    rainChanceAlert: 'ఈ రోజు వర్షం పడే అవకాశం ఉంది. మీ పనులను తదనుగుణంగా ప్లాన్ చేసుకోండి.',
    changeLocation: 'ప్రాంతాన్ని మార్చండి',
    searchLocation: 'మీ గ్రామం/పట్టణం కోసం వెతకండి',
    detectLocation: 'నా ప్రాంతాన్ని గుర్తించు',
    realFeel: 'నిజమైన ఉష్ణోగ్రత',
    uvIndex: 'UV సూచిక',
    lowUV: 'తక్కువ',
    moderateUV: 'మితమైన',
    highUV: 'ఎక్కువ',
    veryHighUV: 'చాలా ఎక్కువ',
    extremeUV: 'తీవ్రమైన',
    weatherSummary: 'వాతావరణ సారాంశం',
    lastUpdated: 'చివరిగా నవీకరించబడింది',
    rainChance: 'వర్షం కురిసే అవకాశం',
    searching: 'వెతుకుతోంది...',
    locationNotFound: 'ప్రాంతం కనుగొనబడలేదు',
    expertConnect: 'నిపుణుల సలహాలు',
    manageExperts: 'నిపుణులు',
    viewMessages: 'యూజర్ సందేశాలు',
    expertMessages: 'యూజర్ ఇన్క్వైరీస్',
    marketplace: 'మార్కెట్ ప్లేస్',
    plantDoctor: 'ప్లాంట్ డాక్టర్',
    apcnfTraceability: 'APCNF ట్రేసబిలిటీ',
    cropCalendar: 'పంట కాలపట్టిక',
    plantingMonth: 'విత్తే నెల',
    harvestMonth: 'కోత నెల',
    recommendedCrops: 'సిఫార్సు చేసిన పంటలు',
    addNewCropEntry: 'కొత్త పంట నమోదును జోడించండి',
    editCropEntry: 'పంట నమోదును సవరించండి',
    cropNameEn: 'పంట పేరు (EN)',
    cropNameTe: 'పంట పేరు (TE)',
    cropNameHi: 'పంట పేరు (HI)',
    detailsEn: 'వివరాలు (EN)',
    detailsTe: 'వివరాలు (TE)',
    detailsHi: 'వివరాలు (HI)',
    practices: 'సాగు పద్ధతులు (Practices)',
    dayOffset: 'విత్తినప్పటి నుండి రోజులు',
    addPractice: 'పద్ధతిని జోడించండి',
    sowingDate: 'విత్తిన తేదీ',
    editSowingDate: 'విత్తిన తేదీని సవరించండి',
    followCrop: 'పంటను అనుసరించండి',
    unfollowCrop: 'అనుసరించవద్దు',
    unfollowCropConfirm: 'మీరు ఈ పంటను అనుసరించడం ఆపాలనుకుంటున్నారా?',
    following: 'అనుసరిస్తున్నారు',
    noCropsFoundCalendar: 'ఈ నెలకు సిఫార్సు చేసిన పంటలు ఏవీ కనుగొనబడలేదు.',
    viewPractices: 'సాగు పద్ధతులు చూడండి',
    hidePractices: 'సాగు పద్ధతులు దాచండి',
    weeklyPractices: 'వారపు సాగు పద్ధతులు',
    markAsComplete: 'పూర్తయినట్లు గుర్తించండి',
    completed: 'పూర్తయింది',
    noPracticesThisWeek: 'ఈ వారం ఎటువంటి పద్ధతులు లేవు.',
    daysSinceSowing: 'విత్తినప్పటి నుండి రోజులు',
    selectSowingDate: 'విత్తిన తేదీని ఎంచుకోండి',
    followCropConfirm: 'మీరు ఈ పంటను అనుసరించాలనుకుంటున్నారా మరియు వారపు పద్ధతులను పొందాలనుకుంటున్నారా?',
    practiceTitleEn: 'పద్ధతి శీర్షిక (EN)',
    practiceTitleTe: 'పద్ధతి శీర్షిక (TE)',
    practiceTitleHi: 'పద్ధతి శీర్షిక (HI)',
    practiceDetailsEn: 'వివరాలు (EN)',
    practiceDetailsTe: 'వివరాలు (TE)',
    practiceDetailsHi: 'వివరాలు (HI)',
    farmingMethod: 'సాగు పద్ధతి',
    farmingMethods: 'సాగు పద్ధతులు',
    certifications: 'ధృవీకరణలు',
    organicCertificates: 'ఆర్గానిక్ సర్టిఫికేట్లు',
    buySellProduce: 'ప్రకృతి ఉత్పత్తులను కొనండి మరియు అమ్మండి',
    copy: 'కాపీ చేయండి',
    share: 'భాగస్వామ్యం చేయండి',
    linkCopied: 'సమాచారం కాపీ చేయబడింది',
    reportSharedDesktop: 'నివేదిక డౌన్‌లోడ్ చేయబడింది మరియు వివరాలు కాపీ చేయబడ్డాయి.',
    detailsCopied: 'వివరాలు కాపీ చేయబడ్డాయి.',
    liveMarketPrices: 'లైవ్ మార్కెట్ ధరలు',
    searchCrops: 'పంటల కోసం వెతకండి...',
    selectDistrict: 'జిల్లాను ఎంచుకోండి',
    selectState: 'రాష్ట్రంను ఎంచుకోండి',
    fetchingPrices: 'మార్కెట్ ధరలు సేకరిస్తోంది...',
    errorFetchingPrices: 'మార్కెట్ ధరల సేకరణలో లోపం. మళ్ళీ ప్రయత్నించండి.',
    noPricesFound: 'ఎంచుకున్న వాటికి ధరలు కనుగొనబడలేదు.',
    minPrice: 'కనీస ధర',
    maxPrice: 'గరిష్ట ధర',
    modalPrice: 'సగటు ధర',
    market: 'మార్కెట్',
    commodity: 'పంట',
    variety: 'రకం',
    arrivalDate: 'వచ్చిన తేదీ',
    refreshing: 'నవీకరిస్తోంది...',
    clearFilters: 'ఫిల్టర్లను తొలగించు',
    menuManagement: 'మెనూ నిర్వహణ',
    profileFieldsManagement: 'ప్రొఫైల్ ఫీల్డ్స్ నిర్వహణ',
    labelKey: 'లేబుల్ కీ',
    placeholderKey: 'ప్లేస్‌హోల్డర్ కీ',
    adminOnly: 'అడ్మిన్ మాత్రమే',
    visible: 'కనిపిస్తుంది',
    required: 'తప్పనిసరి',
    deleteConfirm: 'మీరు ఖచ్చితంగా దీనిని తొలగించాలనుకుంటున్నారా?',
    updateSuccess: 'లిస్టింగ్ విజయవంతంగా నవీకరించబడింది!',
    postSuccess: 'లిస్టింగ్ విజయవంతంగా పోస్ట్ చేయబడింది!',
    profileUpdateSuccess: 'ప్రొఫైల్ విజయవంతంగా నవీకరించబడింది!',
    updateError: 'లిస్టింగ్ నవీకరించడంలో విఫలమైంది.',
    postError: 'లిస్టింగ్ పోస్ట్ చేయడంలో విఫలమైంది.',
    loginSuccess: 'విజయవంతంగా లాగిన్ అయ్యారు!',
    loginFailed: 'లాగిన్ విఫలమైంది. దయచేసి మళ్ళీ ప్రయత్నించండి.',
    signInWithGoogle: 'Google తో లాగిన్ అవ్వండి',
    showInterstitialAd: 'ఇంటర్ స్టీషియల్ యాడ్ చూపించు',
    showRewardedAd: 'రివార్డ్ కోసం వీడియో చూడండి',
    adRewardSuccess: 'అభినందనలు! మీరు రివార్డ్ పొందారు.',
    or: 'లేదా',
    addNewPage: 'కొత్త పేజీని జోడించండి',
    editPage: 'పేజీని సవరించండి',
    pageTitle: 'పేజీ శీర్షిక',
    pageSlug: 'పేజీ స్లగ్ (URL ఉదా: about-us)',
    savePage: 'పేజీని సేవ్ చేయండి',
    noPagesYet: 'ఇంకా పేజీలు సృష్టించబడలేదు.',
    deletePageConfirm: 'మీరు ఖచ్చితంగా ఈ పేజీని తొలగించాలనుకుంటున్నారా?',
    contentInTelugu: 'తెలుగులో కంటెంట్',
    contentInHindi: 'హిందీలో కంటెంట్',
    contentInEnglish: 'ఇంగ్లీష్‌లో కంటెంట్',
    enterLogoUrl: 'లోగో URLని నమోదు చేయండి',
    brandingSettings: 'యాప్ బ్రాండింగ్',
    appLogo: 'యాప్ లోగో',
    logoUploadInstructions: 'అప్లికేషన్ లోగో కోసం చిత్రాన్ని అప్‌లోడ్ చేయండి లేదా URLని నమోదు చేయండి. ఇది లాగిన్ మరియు రిజిస్ట్రేషన్ పేజీలలో చూపబడుతుంది.',
    uploadLogo: 'ఫోటోను అప్‌లోడ్ చేయండి',
    branding: 'బ్రాండింగ్',
    userRole: 'యూజర్ పాత్ర (Role)',
    farmer: 'రైతు',
    aggregator: 'అగ్రిగేటర్ (Aggregator)',
    buyer: 'కొనుగోలుదారు (Buyer)',
    farmerId: 'రైతు ID',
    enterFarmerId: 'రైతు IDని నమోదు చేయండి',
    changePassword: 'పాస్‌వర్డ్ మార్చండి',
    newPassword: 'కొత్త పాస్‌వర్డ్',
    confirmPassword: 'పాస్‌వర్డ్‌ను ధృవీకరించండి',
    passwordChanged: 'పాస్‌వర్డ్ విజయవంతంగా మార్చబడింది!',
    passwordMismatch: 'పాస్‌వర్డ్‌లు సరిపోలలేదు.',
    currentPassword: 'ప్రస్తుత పాస్‌వర్డ్',
    roleRequired: 'దయచేసి ఒక పాత్రను ఎంచుకోండి.',
    cultivationPractices: 'సాగు పద్ధతులు',
    practicedSince: 'ఎప్పటి నుండి సాగు చేస్తున్నారు',
    practicesFollowed: 'అనుసరించే పద్ధతులు',
    addPracticePhoto: 'సాగు పద్ధతి ఫోటోను జోడించండి',
    cropDetails: 'పంట వివరాలు',
    harvestTime: 'అంచనా వేసిన కోత సమయం',
    cultivationArea: 'సాగు భూమి వివరాలు',
    latitude: 'అక్షాంశం (Latitude)',
    longitude: 'రేఖాంశం (Longitude)',
    areaDetails: 'ప్రాంత వివరాలు',
    ratingsAndFeedback: 'రేటింగ్‌లు మరియు ఫీడ్‌బ్యాక్',
    provideFeedback: 'మీ అభిప్రాయాన్ని తెలపండి',
    rating: 'రేటింగ్',
    feedback: 'అభిప్రాయం',
    submitFeedback: 'అభిప్రాయాన్ని సమర్పించండి',
    viewProfileQR: 'ప్రొఫైల్ QR కోడ్‌ను చూడండి',
    downloadQR: 'QR కోడ్‌ను డౌన్‌లోడ్ చేయండి',
    manageProfileSequence: 'ప్రొఫైల్ వరుస క్రమాన్ని నిర్వహించండి',
    arrangeProfile: 'ప్రొఫైల్ అంశాలను అమర్చండి',
    saveSequence: 'వరుస క్రమాన్ని సేవ్ చేయండి',
    farmerProfile: 'రైతు ప్రొఫైల్',
    jeevamrutham: 'జీవామృతం (ఘన/ద్రవ)',
    beejamrutham: 'బీజామృతం (విత్తన శుద్ధి)',
    herbalDecoctions: 'కషాయాలు మరియు ద్రావణాలు',
    otherPractices: 'ఇతర పద్ధతులు',
    addCropRecord: 'పంట రికార్డును జోడించండి',
    estimatedHarvest: 'అంచనా కోత',
    cropArea: 'పంట వైశాల్యం',
    commonCrops: ['వరి', 'పత్తి', 'వేరుశనగ', 'మొక్కజొన్న', 'మిర్చి', 'టమాటా', 'ఉల్లిపాయ', 'శనగ', 'పసుపు', 'కందులు', 'పెసలు', 'మినుములు', 'పొద్దుతిరుగుడు', 'సోయాబీన్', 'గోధుమ', 'చెరకు', 'బంగాళదుంప', 'అరటి'],
  },
  hi: {
    appName: 'प्रकृति मित्र',
    appSubtitle: 'प्राकृतिक खेती मार्गदर्शिका',
    home: 'होम',
    crops: 'फसलें',
    inputs: 'कषायम',
    handbook: 'हैंडबुक',
    advisor: 'AI सलाहकार',
    forum: 'फोरम',
    profile: 'प्रोफ़ाइल',
    videos: 'वीडियो',
    scanner: 'स्कैनर',
    login: 'लॉगिन',
    signup: 'साइन अप',
    logout: 'लॉगआउट',
    offline: 'ऑफलाइन',
    welcome: 'प्रकृति मित्र में आपका स्वागत है',
    tagline: 'प्राकृतिक खेती के साथ धरती की रक्षा करें और स्वास्थ्य बचाएं।',
    getStarted: 'शुरू करें',
    learnMore: 'अधिक जानें',
    naturalFarmingIntro: 'प्राकृतिक खेती का परिचय',
    naturalFarmingDesc: 'रासायनिक उर्वरकों का उपयोग न केवल मिट्टी की उर्वरता को कम करता है बल्कि हमारे स्वास्थ्य के लिए भी खतरा पैदा करता है। प्राकृतिक खेती के माध्यम से कम निवेश में अधिक लाभ प्राप्त किया जा सकता है।',
    naturalKashayams: 'प्राकृतिक कषायम',
    pests: 'कीट/रोग',
    preparations: 'तैयारी विधि',
    ingredients: 'सामग्री',
    usage: 'उपयोग विधि',
    sowingTime: 'बुवाई का समय',
    description: 'विवरण',
    back: 'पीछे',
    search: 'खोजें',
    language: 'भाषा',
    selectLanguage: 'भाषा चुनें',
    telugu: 'तेलुगु',
    english: 'English',
    hindi: 'हिंदी',
    changeLanguage: 'भाषा बदलें',
    menu: 'मेनू',
    settings: 'सेटिंग्स',
    adminPanel: 'एडमिन पैनल',
    calculators: 'कैलकुलेटर',
    pages: 'पेज',
    editCategoryName: 'श्रेणी का नाम बदलें',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    addNewCategory: 'नई श्रेणी जोड़ें',
    categoryName: 'श्रेणी का नाम',
    add: 'जोड़ें',
    edit: 'संपादित करें',
    delete: 'हटाएं',
    subcategoryName: 'उपश्रेणी का नाम',
    addNewSubcategory: 'नई उपश्रेणी जोड़ें',
    privacyPolicy: 'गोपनीयता नीति',
    contentMarkdown: 'सामग्री (मार्डाउन समर्थन)',
    enterPrivacyContent: 'गोपनीयता नीति सामग्री दर्ज करें...',
    privacySaved: 'गोपनीयता नीति सफलतापूर्वक सहेजी गई!',
    savePrivacy: 'गोपनीयता नीति सहेजें',
    termsAndConditions: 'नियम और शर्तें',
    enterTermsContent: 'नियम और शर्तें सामग्री दर्ज करें...',
    termsSaved: 'नियम और शर्तें सफलतापूर्वक सहेजी गईं!',
    saveTerms: 'नियम और शर्तें सहेजें',
    aboutUs: 'हमारे बारे में',
    marketPrices: 'बाजार भाव',
    seedCommonPrices: 'सामान्य भाव जोड़ें',
    localMarketPrices: 'स्थानीय बाजार भाव',
    verifiedLocalPrices: 'सत्यापित स्थानीय भाव',
    manageVerifiedPrices: 'ऐप में दिखने वाले सत्यापित भावों को प्रबंधित करें।',
    addNewPrice: 'नया भाव जोड़ें',
    cropName: 'फसल का नाम',
    pricePerQuintal: 'भाव (प्रति क्विंटल)',
    trend: 'रुझान',
    savePrice: 'भाव सुरक्षित करें',
    editPrice: 'बाजार भाव संपादित करें',
    noVerifiedPrices: 'अभी तक कोई सत्यापित भाव नहीं जोड़ा गया है।',
    seedPricesInstructions: 'वास्तविक डेटा शीघ्रता से जोड़ने के लिए "सामान्य भाव जोड़ें" पर क्लिक करें।',
    addNewCalculator: 'नया कैलकुलेटर जोड़ें',
    editVideo: 'वीडियो संपादित करें',
    videoTitle: 'वीडियो शीर्षक',
    videoUrl: 'वीडियो URL',
    addNewVideo: 'नया वीडियो जोड़ें',
    editItem: 'आइटम संपादित करें',
    itemName: 'आइटम का नाम',
    thumbnailImage: 'थंबनेल छवि',
    uploadImage: 'छवि अपलोड करें',
    changeImage: 'छवि बदलें',
    sections: 'अनुभाग',
    addSection: 'अनुभाग जोड़ें',
    title: 'शीर्षक',
    content: 'सामग्री',
    enterDetails: 'यहाँ विवरण दर्ज करें...',
    noSections: 'अभी तक कोई अनुभाग नहीं जोड़ा गया।',
    saveAndSync: 'सहेजें और सिंक करें',
    editCalculator: 'कैलकुलेटर संपादित करें',
    baseRate: 'आधार दर (किग्रा/एकड़)',
    rows: 'पंक्तियाँ',
    addRow: 'पंक्ति जोड़ें',
    label: 'लेबल',
    sublabel: 'उप लेबल',
    ratio: 'अनुपात',
    kgPerAcre: 'किग्रा/एकड़',
    saveCalculator: 'कैलकुलेटर सहेजें',
    play: 'चलाएं',
    noVideos: 'कोई वीडियो नहीं मिला।',
    noSubcategories: 'कोई उपश्रेणी नहीं मिली।',
    noCalculators: 'कोई कैलकुलेटर नहीं मिला।',
    noCropsFound: 'नोटबुक में कोई फसल नहीं मिली।',
    noInputsFound: 'नोटबुक में कोई कषायम नहीं मिला।',
    moreInfo: 'अधिक जानकारी',
    profileUpdated: 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!',
    profileUpdateFailed: 'प्रोफ़ाइल अपडेट करने में विफल।',
    farmerBrother: 'किसान भाई',
    fullName: 'पूरा नाम',
    yourName: 'आपका नाम',
    phoneNumber: 'फ़ोन नंबर',
    yourPhoneNumber: 'आपका फ़ोन नंबर',
    location: 'स्थान',
    villageTown: 'गांव/शहर',
    enterFullName: 'अपना पूरा नाम दर्ज करें',
    enterPhoneNumber: 'अपना फ़ोन नंबर दर्ज करें',
    enterVillageName: 'अपने गांव का नाम दर्ज करें',
    updating: 'अपडेट हो रहा है...',
    updateDetails: 'विवरण अपडेट करें',
    passwordResetSent: 'पासवर्ड रीसेट लिंक आपके ईमेल पर भेज दिया गया है।',
    passwordTooShort: 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए।',
    invalidEmail: 'कृपया एक वैध ईमेल पता दर्ज करें।',
    somethingWentWrong: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
    forgotPassword: 'पासवर्ड भूल गए?',
    verifyEmail: 'अपना ईमेल सत्यापित करें',
    verificationSent: 'हमने आपको एक सत्यापन ईमेल भेजा है:',
    pleaseVerify: 'कृपया इसे सत्यापित करें और लॉगिन करें।',
    backToLogin: 'लॉगिन पर वापस जाएं',
    userAlreadyExists: 'उपयोगकर्ता पहले से मौजूद है। कृपया लॉगिन करें।',
    incorrectEmailPassword: 'गलत ईमेल या पासवर्ड',
    hello: 'नमस्ते',
    helloFarmer: 'नमस्ते किसान भाई!',
    askAI: 'AI से पूछें',
    dailyWeather: 'आज का मौसम',
    dataNotAvailable: 'डेटा उपलब्ध नहीं है',
    locationRequired: 'स्थानीय मौसम के लिए स्थान पहुंच आवश्यक है',
    weatherLoadFailed: 'मौसम की जानकारी लोड करने में विफल',
    humidity: 'नमी',
    suitableForNaturalFarming: '✓ काम के लिए उपयुक्त',
    notSuitableForFarming: '⚠ छिड़काव/काम के लिए आदर्श स्थिति नहीं है',
    high: 'अधिकतम',
    low: 'न्यूनतम',
    wind: 'हवा की गति',
    clickForForecast: '10-दिवसीय पूर्वानुमान के लिए क्लिक करें',
    communityForum: 'किसान फोरम',
    shareExperience: 'अपने अनुभव साझा करें, दूसरों से सीखें।',
    aiAdvisor: 'AI सलाहकार',
    forecast10Days: '10-दिवसीय मौसम पूर्वानुमान',
    today: 'आज',
    acresCount: 'एकड़ की संख्या:',
    totalPerAcre: 'कुल (प्रति एकड़):',
    importantNote: 'महत्वपूर्ण सूचना',
    naturalFarmingBenefit: 'रासायनिक उर्वरकों का उपयोग न केवल मिट्टी की उर्वरता को कम करता है बल्कि हमारे स्वास्थ्य के लिए भी खतरा पैदा करता है। प्राकृतिक खेती के माध्यम से कम निवेश में अधिक लाभ प्राप्त किया जा सकता है।',
    resetConfirmation: 'क्या आप वाकई सारा डेटा रीसेट करना चाहते हैं? यह फायरस्टोर को साफ़ कर देगा और प्रारंभिक डेटा के साथ फिर से शुरू करेगा।',
    resetSuccess: 'डेटा सफलतापूर्वक रीसेट हो गया!',
    resetError: 'डेटा रीसेट करने में त्रुटि। कंसोल की जाँच करें।',
    deleteVideoConfirm: 'इस वीडियो को हटाएं?',
    deleteCalculatorConfirm: 'इस कैलकुलेटर को हटाएं?',
    deleteCategoryConfirm: 'इस श्रेणी और इसके सभी आइटम हटाएं?',
    deleteSubcategoryConfirm: 'इस उपश्रेणी को हटाएं?',
    noSubcategoriesYet: 'अभी तक कोई उपश्रेणी नहीं है।',
    uploadThumbnail: 'थंबनेल अपलोड करें',
    noVideosYet: 'अभी तक कोई वीडियो नहीं जोड़ा गया।',
    noDetailsAvailable: 'इस आइटम के लिए अभी तक कोई विवरण उपलब्ध नहीं है।',
    noMedia: 'कोई मीडिया नहीं',
    email: 'ईमेल',
    password: 'पासवर्ड',
    processing: 'प्रसंस्करण...',
    sendResetLink: 'रीसेट लिंक भेजें',
    alreadyHaveAccount: 'पहले से ही एक खाता है? लॉगिन करें',
    dontHaveAccount: 'खाता नहीं है? साइन अप करें',
    reportGeneratedVia: 'प्रकृति मित्र AI के माध्यम से उत्पन्न इस रिपोर्ट को देखें।',
    sharedVia: 'प्रकृति मित्र AI के माध्यम से साझा किया गया',
    acres: 'एकड़',
    total: 'कुल',
    accessDenied: 'पहुंच अस्वीकृत। केवल एडमिन ही इस पैनल तक पहुंच सकते हैं।',
    noContentYet: 'अभी तक कोई सामग्री नहीं है। कृपया एडमिन पैनल में सामग्री जोड़ें।',
    resetAppData: 'ऐप डेटा रीसेट करें',
    resetting: 'रीसेट हो रहा है...',
    resetData: 'डेटा रीसेट',
    currentLocation: 'वर्तमान स्थान',
    vijayawada: 'विजयवाड़ा',
    sunny: 'धूप',
    mainlyClear: 'मुख्य रूप से साफ',
    partlyCloudy: 'आंशिक रूप से बादल',
    cloudy: 'बादल छाए रहेंगे',
    fog: 'कोहरा',
    drizzle: 'बूंदाबांदी',
    rain: 'बारिश',
    heavyRain: 'भारी बारिश',
    thunderstorm: 'गरज के साथ बारिश',
    snow: 'बर्फबारी',
    newCalculator: 'नया कैलकुलेटर',
    moveUp: 'ऊपर ले जाएं',
    moveDown: 'नीचे ले जाएं',
    moveItemUp: 'आइटम ऊपर ले जाएं',
    moveItemDown: 'आइटम नीचे ले जाएं',
    moveSectionUp: 'अनुभाग ऊपर ले जाएं',
    moveSectionDown: 'अनुभाग नीचे ले जाएं',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    weatherAlerts: 'मौसम अलर्ट',
    noAlerts: 'फिलहाल कोई अलर्ट नहीं है',
    heavyRainAlert: 'भारी बारिश का पूर्वानुमान! फसल सुरक्षा उपाय करें।',
    highTempAlert: 'उच्च तापमान! पर्याप्त पानी प्रदान करें।',
    stormAlert: 'तूफान की चेतावनी! सुरक्षित रहें।',
    heatWaveAlert: 'लू की चेतावनी! दोपहर में बाहर निकलने से बचें।',
    frostAlert: 'पाला संभव! फसल को ढंक कर रखें।',
    fungalAlert: 'उच्च आर्द्रता (>90%)! कवक रोगों का खतरा। फसलों की निगरानी करें।',
    visibilityAlert: 'घना कोहरा! कम दृश्यता, खेत में सावधान रहें।',
    rainChanceAlert: 'आज बारिश की प्रबल संभावना है। अपनी गतिविधियों की योजना तदनुसार बनाएं।',
    changeLocation: 'स्थान बदलें',
    searchLocation: 'अपने शहर/गांव की खोज करें',
    detectLocation: 'स्थान का पता लगाएं',
    realFeel: 'वास्तविक अनुभव',
    uvIndex: 'UV सूचकांक',
    lowUV: 'कम',
    moderateUV: 'मध्यम',
    highUV: 'उच्च',
    veryHighUV: 'बहुत उच्च',
    extremeUV: 'अत्यधिक',
    weatherSummary: 'मौसम सारांश',
    lastUpdated: 'पिछली बार अपडेट किया गया',
    rainChance: 'बारिश की संभावना',
    searching: 'खोज रहे हैं...',
    locationNotFound: 'स्थान नहीं मिला',
    expertConnect: 'विशेषज्ञ से संपर्क करें',
    manageExperts: 'विशेषज्ञों का प्रबंधन करें',
    viewMessages: 'उपयोगकर्ता संदेश',
    expertMessages: 'उपयोगकर्ता पूछताछ',
    marketplace: 'बाज़ार',
    plantDoctor: 'प्लांट डॉक्टर',
    apcnfTraceability: 'APCNF ट्रैसेबिलिटी',
    cropCalendar: 'फसल कैलेंडर',
    plantingMonth: 'बुवाई का महीना',
    harvestMonth: 'कटाई का महीना',
    recommendedCrops: 'अनुशंसित फसलें',
    addNewCropEntry: 'नई फसल प्रविष्टि जोड़ें',
    editCropEntry: 'फसल प्रविष्टि संपादित करें',
    cropNameEn: 'फसल का नाम (EN)',
    cropNameTe: 'फसल का नाम (TE)',
    cropNameHi: 'फसल का नाम (HI)',
    detailsEn: 'विवरण (EN)',
    detailsTe: 'विवरण (TE)',
    detailsHi: 'विवरण (HI)',
    practices: 'खेती के तरीके (Practices)',
    dayOffset: 'बुवाई के बाद के दिन',
    addPractice: 'तरीका जोड़ें',
    sowingDate: 'बुवाई की तारीख',
    editSowingDate: 'बुवाई की तारीख संपादित करें',
    followCrop: 'फसल का पालन करें',
    unfollowCrop: 'अनफ़ॉलो करें',
    unfollowCropConfirm: 'क्या आप इस फसल को अनफ़ॉलो करना चाहते हैं?',
    following: 'फ़ॉलो कर रहे हैं',
    noCropsFoundCalendar: 'इस महीने के लिए कोई अनुशंसित फसल नहीं मिली।',
    viewPractices: 'खेती के तरीके देखें',
    hidePractices: 'खेती के तरीके छुपाएं',
    weeklyPractices: 'साप्ताहिक खेती के तरीके',
    markAsComplete: 'पूर्ण के रूप में चिह्नित करें',
    completed: 'पूरा हुआ',
    noPracticesThisWeek: 'इस सप्ताह के लिए कोई तरीके नहीं हैं।',
    daysSinceSowing: 'बुवाई के बाद के दिन',
    selectSowingDate: 'बुवाई की तारीख चुनें',
    followCropConfirm: 'क्या आप इस फसल का पालन करना चाहते हैं और साप्ताहिक तरीके प्राप्त करना चाहते हैं?',
    practiceTitleEn: 'तरीका शीर्षक (EN)',
    practiceTitleTe: 'तरीका शीर्षक (TE)',
    practiceTitleHi: 'तरीका शीर्षक (HI)',
    practiceDetailsEn: 'विवरण (EN)',
    practiceDetailsTe: 'विवरण (TE)',
    practiceDetailsHi: 'विवरण (HI)',
    farmingMethod: 'खेती की विधि',
    farmingMethods: 'खेती की विधियां',
    certifications: 'प्रमाणपत्र',
    organicCertificates: 'जैविक प्रमाणपत्र',
    buySellProduce: 'प्राकृतिक उत्पाद खरीदें और बेचें',
    copy: 'कॉपी करें',
    share: 'साझा करें',
    linkCopied: 'सामग्री कॉपी कर ली गई है',
    reportSharedDesktop: 'रिपोर्ट डाउनलोड हो गई है और विवरण कॉपी कर लिए गए हैं।',
    detailsCopied: 'विवरण कॉपी कर लिए गए हैं।',
    liveMarketPrices: 'लाइव बाजार भाव',
    searchCrops: 'फसलें खोजें...',
    selectDistrict: 'जिला चुनें',
    selectState: 'राज्य चुनें',
    fetchingPrices: 'बाजार भाव प्राप्त कर रहे हैं...',
    errorFetchingPrices: 'बाजार भाव प्राप्त करने में त्रुटि। कृपया बाद में पुनः प्रयास करें।',
    noPricesFound: 'चयनित फिल्टर के लिए कोई भाव नहीं मिला।',
    minPrice: 'न्यूनतम भाव',
    maxPrice: 'अधिकतम भाव',
    modalPrice: 'मॉडल भाव',
    market: 'मंडी',
    commodity: 'वस्तु',
    variety: 'किस्म',
    arrivalDate: 'पहुंच तिथि',
    refreshing: 'अपडेट हो रहा है...',
    clearFilters: 'फ़िल्टर साफ करें',
    menuManagement: 'मेनू प्रबंधन',
    profileFieldsManagement: 'प्रोफ़ाइल फ़ील्ड प्रबंधन',
    labelKey: 'लेबल कुंजी',
    placeholderKey: 'प्लेसहोल्डर कुंजी',
    adminOnly: 'केवल एडमिन',
    visible: 'दृश्यमान',
    required: 'आवश्यक',
    deleteConfirm: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    updateSuccess: 'लिस्टिंग सफलतापूर्वक अपडेट की गई!',
    postSuccess: 'लिस्टिंग सफलतापूर्वक पोस्ट की गई!',
    profileUpdateSuccess: 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!',
    updateError: 'लिस्टिंग अपडेट करने में विफल।',
    postError: 'लिस्टिंग पोस्ट करने में विफल।',
    loginSuccess: 'सफलतापूर्वक लॉगिन किया गया!',
    loginFailed: 'लॉगिन विफल रहा। कृपया पुनः प्रयास करें।',
    signInWithGoogle: 'Google के साथ साइन इन करें',
    showInterstitialAd: 'इंटरस्टिशियल विज्ञापन दिखाएं',
    showRewardedAd: 'इनाम के लिए वीडियो देखें',
    adRewardSuccess: 'बधाई हो! आपने इनाम जीता।',
    or: 'या',
    addNewPage: 'नया पेज जोड़ें',
    editPage: 'पेज संपादित करें',
    pageTitle: 'पेज का शीर्षक',
    pageSlug: 'पेज स्लॉग (URL जैसे: about-us)',
    savePage: 'पेज सहेजें',
    noPagesYet: 'अभी तक कोई पेज नहीं बनाया गया है।',
    deletePageConfirm: 'क्या आप वाकई इस पेज को हटाना चाहते हैं?',
    contentInTelugu: 'तेलुगु में सामग्री',
    contentInHindi: 'हिंदी में सामग्री',
    contentInEnglish: 'अंग्रेजी में सामग्री',
    enterLogoUrl: 'लोगो URL दर्ज करें',
    brandingSettings: 'ऐप ब्रांडिंग',
    appLogo: 'ऐप लोगो',
    logoUploadInstructions: 'एप्लिकेशन लोगो के लिए एक छवि अपलोड करें या URL दर्ज करें। यह लॉगिन और पंजीकरण पृष्ठों पर दिखाया जाएगा।',
    uploadLogo: 'फोटो अपलोड करें',
    branding: 'ब्रांडिंग',
    userRole: 'उपयोगकर्ता भूमिका',
    farmer: 'किसान',
    aggregator: 'एग्रीगेटर',
    buyer: 'खरीददार',
    farmerId: 'किसान आईडी',
    enterFarmerId: 'किसान आईडी दर्ज करें',
    changePassword: 'पासवर्ड बदलें',
    newPassword: 'नया पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    passwordChanged: 'पासवर्ड सफलतापूर्वक बदल गया!',
    passwordMismatch: 'पासवर्ड मेल नहीं खाते।',
    currentPassword: 'वर्तमान पासवर्ड',
    roleRequired: 'कृपया एक भूमिका चुनें।',
    cultivationPractices: 'खेती के तरीके',
    practicedSince: 'कब से अभ्यास कर रहे हैं',
    practicesFollowed: 'अपनाए गए तरीके',
    addPracticePhoto: 'अभ्यास फोटो जोड़ें',
    cropDetails: 'फसल विवरण',
    harvestTime: 'अनुमानित कटाई का समय',
    cultivationArea: 'खेती क्षेत्र',
    latitude: 'अक्षांश',
    longitude: 'देशांतर',
    areaDetails: 'क्षेत्र विवरण',
    ratingsAndFeedback: 'रेटिंग और फीडबैक',
    provideFeedback: 'फीडबैक दें',
    rating: 'रेटिंग',
    feedback: 'फीडबैक',
    submitFeedback: 'फीडबैक सबमिट करें',
    viewProfileQR: 'प्रोफ़ाइल क्यूआर देखें',
    downloadQR: 'क्यूआर डाउनलोड करें',
    manageProfileSequence: 'प्रोफ़ाइल अनुक्रम प्रबंधित करें',
    arrangeProfile: 'प्रोफ़ाइल तत्व व्यवस्थित करें',
    saveSequence: 'अनुक्रम सहेजें',
    farmerProfile: 'किसान प्रोफाइल',
    jeevamrutham: 'जीवामृत (ठोस/तरल)',
    beejamrutham: 'बीजामृत (बीज उपचार)',
    herbalDecoctions: 'हर्बल काढ़ा और समाधान',
    otherPractices: 'अन्य अभ्यास',
    addCropRecord: 'फसल रिकॉर्ड जोड़ें',
    estimatedHarvest: 'अनुमानित कटाई',
    cropArea: 'फसल क्षेत्र',
    commonCrops: ['धान', 'कपास', 'मूंगफली', 'मक्का', 'मिर्च', 'टमाटर', 'प्याज', 'चना', 'हल्दी', 'अरहर', 'मूंग', 'उड़द', 'सूरजमुखी', 'सोयाबीन', 'गेहूं', 'गन्ना', 'आलू', 'केला'],
  }
};

const CROP_MAPPINGS: Record<string, string> = {
  // Telugu mappings
  'వరి': 'Paddy',
  'ప్యాడీ': 'Paddy',
  'బియ్యం': 'Rice',
  'మిర్చి': 'Chilli',
  'మిరప': 'Chilli',
  'పత్తి': 'Cotton',
  'వేరుశనగ': 'Groundnut',
  'శనగలు': 'Bengal Gram',
  'శనగ': 'Bengal Gram',
  'కందులు': 'Red Gram',
  'మినుములు': 'Black Gram',
  'పెసలు': 'Green Gram',
  'మొక్కజొన్న': 'Maize',
  'టమాటా': 'Tomato',
  'ఉల్లిపాయ': 'Onion',
  'పసుపు': 'Turmeric',
  'జొన్నలు': 'Jowar',
  'సజ్జలు': 'Bajra',
  'రాగులు': 'Ragi',
  'కేసరి': 'Safflower',
  'పొద్దుతిరుగుడు': 'Sunflower',
  'చెరకు': 'Sugarcane',
  'అరటి': 'Banana',
  'మామిడి': 'Mango',
  'నిమ్మ': 'Lemon',
  'బొప్పాయి': 'Papaya',
  
  // Hindi mappings
  'धान': 'Paddy',
  'चावल': 'Rice',
  'मिर्च': 'Chilli',
  'कपास': 'Cotton',
  'मूंगफली': 'Groundnut',
  'चना': 'Bengal Gram',
  'अरहर': 'Red Gram',
  'उड़द': 'Black Gram',
  'मूंग': 'Green Gram',
  'मक्का': 'Maize',
  'टमाटर': 'Tomato',
  'प्याज': 'Onion',
  'हल्दी': 'Turmeric',
  'ज्वार': 'Jowar',
  'बाजरा': 'Bajra',
  'रागी': 'Ragi',
  'सूरजमुखी': 'Sunflower',
  'गन्ना': 'Sugarcane',
  'केला': 'Banana',
  'आम': 'Mango',
  'नींबू': 'Lemon',
  'पपीता': 'Papaya'
};

export const getEnglishCropName = (crop: string): string => {
  return CROP_MAPPINGS[crop] || crop;
};
